import {Component, Input, OnInit} from '@angular/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {BehaviorSubject, Observable} from 'rxjs';
import {UxInteractions} from '@app/4dm1n/users-list/store/users-list.reducers';
import {currentUxInteraction} from '@app/4dm1n/users-list/store/users-list.selector';
import {IInbeUser} from '@app/4dm1n/users-list/store/_model';
import {selectAdminOrganizations} from '@app/4dm1n/users-list/store/organizations/organizations-list.selectors';
import {Router} from '@angular/router';
import {environment} from '@environments/environment';
import {confirm} from 'devextreme/ui/dialog';
import {HttpClient} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {DisableUser, UpdateUserDetail} from '@app/4dm1n/users-list/store/users-list.actions';

@Component({
  selector: 'app-main-form',
  templateUrl: './main-form.component.html',
  styleUrls: ['./main-form.component.scss']
})
export class MainFormComponent extends OnDestroyMixin implements OnInit {

  private BASE_URL = environment.apiUrl;
  uxInteractions$: Observable<UxInteractions> = this.store.select(currentUxInteraction).pipe(untilComponentDestroyed(this));

  public disablingUser$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public updatingUser$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  // currentUser$: Observable<IInbeUser> = this.store.select(currentUserDetail).pipe(untilComponentDestroyed(this));
  @Input()
  currentUser: IInbeUser = null;

  organizationList$: Observable<any[]> = this.store.select(selectAdminOrganizations).pipe(untilComponentDestroyed(this));

  fUser: UntypedFormGroup = new UntypedFormGroup({});


  constructor(
    private store: Store<AppState>,
    public router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {
    super();
  }

  ngOnInit(): void {

    this.fUser.addControl('userId', new UntypedFormControl(''));
    this.fUser.addControl('firstname', new UntypedFormControl(''));
    this.fUser.addControl('lastname', new UntypedFormControl(''));
    this.fUser.addControl('email', new UntypedFormControl('', [Validators.required, Validators.email]));

    this.fUser.addControl('newPassword', new UntypedFormControl(''));

    this.fUser.addControl('organizationId', new UntypedFormControl(''));

    this.fUser.addControl('userAccess', new UntypedFormControl(''));

    this.fUser.patchValue(this.currentUser);

    // this.currentUser$.pipe(untilComponentDestroyed(this)).subscribe((datas) => {
    // this.store.select(currentUserDetail).pipe(untilComponentDestroyed(this)).subscribe((datas) => {
    //
    //   if (datas) {
    //     this.currentUser = datas;
    //     console.log('From observable:', datas);
    //     console.log('From property', this.currentUser);
    //     this.fUser.patchValue(datas);
    //     if (datas.type === 'client') {
    //       // ?
    //     }
    //   }
    //
    // });

  }

  getLoginUrl(): string {

    if (this.currentUser.type === 'client') {
      return `${window.location.origin}${this.router.createUrlTree(['/log-in', this.currentUser.jwtToken]).toString()}`;
    } else {

      return `${environment.appCommunityUrl}/directLink/login?jwtToken=${this.currentUser.jwtToken}`;

    }


  }

  updateUser() {
    confirm(
      this.translate.instant('Mettre à jour le client ?'),
      this.translate.instant('Mise à jour')
    )
      .then((dialogResult) => {
          if (dialogResult) {

            this.updatingUser$.next(true);

            const url = `${this.BASE_URL}/4dm1n/actions`;
            this.http.post<any>(url, {
              action: 'updateUserClient',
              params: this.fUser.getRawValue(),
            }).subscribe(
              {
                next: response => {
                  console.log(response.data.datas);
                  this.updatingUser$.next(false);
                  this.toastr.success('The user was updated successfully');

                  this.store.dispatch(UpdateUserDetail({user: this.fUser.getRawValue()}));

                },
                error: err => {
                  this.updatingUser$.next(false);
                  console.log(err);
                },
              }
            );


          }
        }
      );
    if (this.currentUser.type === 'client') {


    } else {

    }

  }

  disableUser() {


    // if (this.currentUser.type === 'client') {

    confirm(
      `Deactivate ${this.currentUser.type}`,
      'Deactivate'
    )
      .then((dialogResult) => {
          if (dialogResult) {

            this.disablingUser$.next(true);

            const url = `${this.BASE_URL}/4dm1n/actions`;
            this.http.post<any>(url, {
              action: this.currentUser.type === 'client' ? 'disableUserClient' : 'disableUserContributor',
              params: this.fUser.getRawValue(),
            }).subscribe(
              {
                next: response => {

                  console.log(response.data.datas);

                  this.disablingUser$.next(false);
                  this.toastr.success('The user was disabled successfully');

                  this.store.dispatch(DisableUser({user: this.fUser.getRawValue()}));

                },
                error: err => {
                  this.disablingUser$.next(false);
                  console.log(err);
                },
              }
            );


          }
        }
      );

    // } else {
    //
    // }

  }
}
